import {
  HttpClient,
} from "@angular/common/http";
import { registerLocaleData } from "@angular/common";

import localeNL from "@angular/common/locales/nl";
import localeDE from "@angular/common/locales/de";
import localeEN from "@angular/common/locales/en";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

registerLocaleData(localeNL, "NL");
registerLocaleData(localeDE, "DE");
registerLocaleData(localeEN, "EN");

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
